import { render, staticRenderFns } from "./MessagesFooter.vue?vue&type=template&id=039721b1&scoped=true&"
import script from "./MessagesFooter.vue?vue&type=script&lang=js&"
export * from "./MessagesFooter.vue?vue&type=script&lang=js&"
import style0 from "./MessagesFooter.vue?vue&type=style&index=0&id=039721b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039721b1",
  null
  
)

export default component.exports